export default class Serie {
  constructor(args) {
    this.id = args?.id;
    this.brandId = args?.brandId;
    this.brandName = args?.brandName;
    this.cloudinaryImageId = args?.cloudinaryImageId;
    this.dataProviderId = args?.dataProviderId;
    this.dataProviderBrandId = args?.dataProviderBrandId;
    this.dataProviderProductSerieId = args?.dataProviderProductSerieId;
    this.imageUrl = args?.imageUrl;
    this.imageTransformation = args?.imageTransformation;
    this.infoText = args?.infoText;
    this.infoTitle = args?.infoTitle;
    this.name = args?.name;
    this.supplierId = args?.supplierId;
    this.supplierName = args?.supplierName;
    this.productCount = args?.productCount;
  }
}
